module.exports = __webpack_public_path__ + "img/invoice-at-male-banner.d0a15f4c.png";